import { Link } from "react-router-dom";
import logo from "../../assets/images/logo-icon.png";
import { BsChevronDown } from "react-icons/bs";
import { Popover } from "@mantine/core";
import { RiLoginBoxLine } from "react-icons/ri";

import { useContext, useEffect, useState } from "react";
import fetchAllSites from "../../services/fetchAllSites";
import { useDispatch, useSelector } from "react-redux";
import { changeSite } from "../../store/slices/site";
import { AuthContext } from "../../contexts/AuthContext";
import Profile from "./Header/components/Profile";
import autoinc from "../../assets/images/autoinc.png";
import toyota from "../../assets/images/toyota.png";

export default function HomeHeader() {
  const { user, token } = useContext(AuthContext);
  const { selectedSite } = useSelector((state: any) => state.site);
  const [loading, setLoading] = useState(false);
  const [site, setSite] = useState({ name: "Toyota HQ ( Dar es salaam" });
  const [sites, setSites] = useState<any>([]);
  const [opened, setOpened] = useState(false);
  const [isVisible, setVisible] = useState(false);
  const dispatch = useDispatch();

  const handleAllSites = async () => {
    setLoading(true);
    const data = await fetchAllSites();

    const only = data?.payload.filter((item: any) => !item.isDealer);
    setSites(only);
    setSite(user?.site);
    dispatch(changeSite(user?.site));
    setLoading(false);
  };

  const handleChangeSite = (site: any) => {
    setSite(site);
    dispatch(changeSite(site));
  };

  useEffect(() => {
    handleAllSites();
  }, []);

  return (
    <div className="h-16 bg-toyota flex flex-row justify-between items-center">
      <div className="flex flex-row items-center mx-4 text-white text-2xl font-bold">
        <img src={logo} alt="Logo" height={20} width={50} />
        <span className="ml-4 text-sm hidden sm:block md:text-2xl border-l pl-3">
          TOYOTA - VMS
        </span>
        <span className="ml-4 block sm:hidden text-2xl font-normal">VMS</span>
      </div>
      <div className="flex flex-row items-center">
        <div className="text-white font-bold bg-green-100">
          <Popover
            className="cursor:pointer focus:outline-none hover:text-toyota bg-toyota"
            opened={opened}
            onClose={() => setOpened(false)}
            target={
              <div
                onClick={() => setOpened((o) => !o)}
                className="cursor-pointer hover:font-extrabold"
              >
                <div className="flex flex-row  items-center hover:text-gray-200 text-white border-b border-toyota py-2">
                {selectedSite?.isAutoInc ? (
                    <img src={autoinc} alt="" className="border" width={20} />
                  ) : (
                    <img src={toyota} alt="" className="" width={20} />
                  )}
                    <div className="mx-1 truncate w-28">

                  {selectedSite?.name}
                    </div>
                  <div className="ml-2">
                    <BsChevronDown color={"#FFFFFF"} />
                  </div>
                </div>
              </div>
            }
            width={260}
            position="bottom"
            withArrow
          >
            <div className="flex flex-col">
              {sites?.map((site: any) => (
                <button
                  className="cursor-pointer hover:text-toyota flex items-center focus:outline-none py-1 border-b border-gray-100"
                  onClick={() => {
                    setSite(site);
                    handleChangeSite(site);
                    setOpened((o) => !o);
                  }}
                  key={site.id}
                >
                  {site?.isAutoInc ? (
                    <img src={autoinc} alt="" width={20} />
                  ) : (
                    <img src={toyota} alt="" width={20} />
                  )}
                  <div className="ml-2 truncate">{site?.name} </div>
                </button>
              ))}
            </div>
          </Popover>
        </div>
        {token ? (
          <div className="ml-2 mr-4 z-50">
            <Profile isVisible={isVisible} setVisible={setVisible} />
          </div>
        ) : (
          <Link to={"/login"} className="ml-2 mr-4">
            <RiLoginBoxLine color="#FFFFFF" size={22} />
          </Link>
        )}
      </div>
    </div>
  );
}
